import React from "react";
import { Link } from "react-scroll";
import Logo from "../elements/Logo";

function Header({ light, logoSource, toggleMenu, headerToggler }) {
  const handleClasses = () => {
    let classes = "desktop-header-1 d-flex align-items-start flex-column";
    if (light & toggleMenu) {
      classes += " light open";
    } else if (toggleMenu) {
      classes += " open";
    } else if (light) {
      classes += " light";
    }
    return classes;
  };
  const handleMobileClasses = () => {
    let classes = "mobile-header-1";
    if (light & toggleMenu) {
      classes += " light open";
    } else if (toggleMenu) {
      classes += " open";
    } else if (light) {
      classes += " light";
    }
    return classes;
  };
  return (
    <>
      <header className={handleMobileClasses()}>
        <div className="container">
          <div className="menu-icon d-inline-flex mr-4">
            <button onClick={headerToggler}>
              <span></span>
            </button>
          </div>
        </div>
      </header>
      <header className={handleClasses()}>
        {/*<div className="header-top">*/}
        {/*  /!*<Logo logoSource={logoSource} />*!/*/}
        {/*  /!*<h3 className="site-title">Salim I. Amoukou</h3>*!/*/}
        {/*  <p className="site-subtitle">AI Research Scientist</p>*/}
        {/*  <div className="header-divider"></div>*/}
        {/*</div>*/}
        <nav className="header-nav">
          <ul className="vertical-menu scrollspy">
            <li>
              <Link
                activeClass="active"
                to="section-home"
                spy={true}
                smooth={true}
                duration={500}
                offset={-100}
              >
                <i className="icon-home"></i>
                <span className="menu-text">Home</span>
              </Link>
            </li>
            <li>
              <Link
                activeClass="active"
                to="section-about"
                spy={true}
                smooth={true}
                duration={500}
                offset={-100}
              >
                <i className="icon-user-following"></i>
                <span className="menu-text">About</span>
              </Link>
            </li>
            <li>
              <Link
                  activeClass="active"
                  to="section-papers"
                  spy={true}
                  smooth={true}
                  duration={500}
                offset={-100}
              >
                <i className="icon-docs"></i>
                <span className="menu-text">Papers</span>
              </Link>
            </li>
            <li>
              <Link
                activeClass="active"
                to="section-awards"
                spy={true}
                smooth={true}
                duration={500}
                offset={-100}
              >
                <i className="icon-trophy"></i>
                <span className="menu-text">Awards</span>
              </Link>
            </li>
            <li>
              <Link
                activeClass="active"
                to="section-experiences"
                spy={true}
                smooth={true}
                duration={500}
                offset={-100}
              >
                <i className="icon-graduation"></i>
                <span className="menu-text">Experience</span>
              </Link>
            </li>
            <li>
              <Link
                activeClass="active"
                to="section-contact"
                spy={true}
                smooth={true}
                duration={500}
                offset={-100}
              >
                <i className="icon-bubbles"></i>
                <span className="menu-text">Contact</span>
              </Link>
            </li>
          </ul>
        </nav>

      </header>
    </>
  );
}

export default Header;
